export const formatText = (text: string) => 
text.split('\n').map((textLine, index) => <>{index > 0 && <br/>}<span className="p-0 m-0">{textLine}</span></>
      )